<template>
    <vue-custom-scrollbar id="workspace-photo-tips" class="workspace-module-container">
        <div class="workspace-photo-tips-label">
            Загрузка фотографий
        </div>
        <div class="workspace-photo-tips-description">
            Для достижения наилучших результатов мы рекомендуем использовать подходящие изображения:
        </div>
        <div class="photo-tips-grid-container">
            <div class="photo-tips-left-grid">
                <div class="photo-tip-container left-tip">
<!--                    <div class="tips-img-container">-->
                        <img class="photo-tip-img-left" :src="urlForStatic('/img/projectPreviewsDemo/photo_tip_1.png')"/>
<!--                    </div>-->
                    <div class="photo-tip-text-box">
                        <div class="photo-tip-label">
                            <SVGCross class="red-cross"/>
                            Нечёткое изображение
                        </div>
                        <div class="photo-tip-text">
                            Изображение объекта должно быть в фокусе и полностью помещаться в кадр
                        </div>
                    </div>
                </div>
                <div class="photo-tip-container left-tip">
<!--                    <div class="tips-img-container">-->
                        <img class="photo-tip-img-left" :src="urlForStatic('/img/projectPreviewsDemo/photo_tip_2.png')"/>
<!--                    </div>-->
                    <div class="photo-tip-text-box">
                        <div class="photo-tip-label">
                            <SVGCross class="red-cross"/>
                            Фото слишком тёмное
                        </div>
                        <div class="photo-tip-text">
                            Фотография сделана при недостаточной освещенности, что будет сказываться на точности проектирования
                        </div>
                    </div>
                </div>
                <div class="photo-tip-container left-tip">
<!--                    <div class="tips-img-container">-->
                        <img class="photo-tip-img-left" :src="urlForStatic('/img/projectPreviewsDemo/photo_tip_3.png')"/>
<!--                    </div>-->
                    <div class="photo-tip-text-box">
                        <div class="photo-tip-label">
                            <SVGCross class="red-cross"/>
                            Посторонние объекты
                        </div>
                        <div class="photo-tip-text">
                            Фотография содержит другие объекты на переднем плане, которые мешают проектированию
                        </div>
                    </div>
                </div>
                <div class="photo-tip-container left-tip">
                    <!--                    <div class="tips-img-container">-->
                    <img class="photo-tip-img-left" :src="urlForStatic('/img/projectPreviewsDemo/photo_tip_5.jpeg')"/>
                    <!--                    </div>-->
                    <div class="photo-tip-text-box">
                        <div class="photo-tip-label">
                            <SVGCross class="red-cross"/>
                            Неправильная перспектива
                        </div>
                        <div class="photo-tip-text">
                            Линии углов дома должны быть наиболее паралельны вертикалям фотографии
                        </div>
                    </div>
                </div>
            </div>
            <div class="photo-tip-container right-tip">
                <img class="photo-tip-img-right" :src="urlForStatic('/img/projectPreviewsDemo/photo_tip_4.jpg')"/>
                <div class="photo-tip-text-box">
                    <div class="photo-tip-label">
                        Подходящее изображение
                    </div>
                    <div class="list-item">
                        <SVGChecked class="green-check"/>
                        <span class="photo-tip-text-left">Изображение объекта в фокусе</span>
                    </div>
                    <div class="list-item">
                        <SVGChecked class="green-check"/>
                        <span class="photo-tip-text-left">Здание полностью помещается в кадр</span>
                    </div>
                    <div class="list-item">
                        <SVGChecked class="green-check"/>
                        <span class="photo-tip-text-left">Фото сделано при достаточном освещении</span>
                    </div>
                    <div class="list-item">
                        <SVGChecked class="green-check"/>
                        <span class="photo-tip-text-left">На фото отсутствуют посторонние объекты, мешающие обзору</span>
                    </div>
                </div>
            </div>
        </div>
    </vue-custom-scrollbar>
</template>

<script>
    import {urlForStaticVue} from "../common";
    import SVGCross from "../SVG/SVGCross";
    import SVGChecked from "../SVG/SVGChecked";
    import vueCustomScrollbar from 'vue-custom-scrollbar';

    export default {
        name: "WorkspacePhotoTips",
        components: {
            SVGChecked,
            SVGCross,
            vueCustomScrollbar
        },
        mixins: [urlForStaticVue],
        mounted() {
            const photosID = Object.keys(this.$store.getters["active/GET_ALL_PHOTO"]);
            if (photosID.length > 0) {
                this.$router.replace({name: "viewPhoto", params: {photoID: photosID[0]}}).catch(() => {})
            }
        }
    }
</script>

<style scoped>
    @media (max-width: 1500px) {
        .photo-tip-text {
            font-size: 14px !important;
        }
        .photo-tip-text-left {
            font-size: 14px !important;
        }
        .photo-tip-label {
            font-size: 14px !important;
        }
    }

    #workspace-photo-tips {
        background-color: #f2f2f2;
        display: block;
        padding: 4%;
        box-sizing: border-box;
    }

    .workspace-photo-tips-label {
        color: #303030;
        font-weight: bold;
        font-size: 18px;
        margin: 2% 0;
    }

    .workspace-photo-tips-description {
        color: #303030;
        margin: 2% 0;
    }

    .photo-tips-grid-container {
        display: grid;
        grid-template-columns: 60% 37%;
        grid-column-gap: 3%;
    }

    .photo-tips-left-grid {
        display: grid;
        grid-template-rows: auto auto auto;
        grid-row-gap: 25px;
    }

    .photo-tip-container {
        background-color: white;
    }

    .left-tip {
        display: grid;
        grid-template-columns: auto auto;
    }

    .right-tip {

    }

    .photo-tip-img-left {
        height: 100%;
        width: 275px;
    }

    .photo-tip-img-right {
        width: 100%;
    }

    .photo-tip-text-box {
        margin: 10px;
    }

    .photo-tip-label {
        margin-bottom: 20px;
        color: #303030;
        font-weight: bold;
        text-align: center;
    }

    .red-cross {
        color: #D83336;
        width: 20px;
        height: 20px;
    }

    .green-check {
        color: #28A745;
        width: 20px;
        height: 20px;
    }

    .photo-tip-text {
        color: #303030;
        text-align: center;
    }

    .photo-tip-text-left {
        margin-bottom: 20px;
        color: #303030;
        text-align: left;
    }

    .list-item {
        text-align: left;
        display: grid;
        grid-template-columns: 40px auto;
    }
</style>
